import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Material } from './Material';

export const Type = intersect(
	struct({
		materials: array(Material),
	})
)(
	partial({
		ingredientName: string,
	})
);
